export default class MainContact {
    constructor() {
        this.section = document.querySelector(".no-main-contact");
        if (!this.section) return;

        this.init();
    }

    init() {
        const tl = gsap.timeline({
            scrollTrigger: {
                pin: true,
                trigger: this.section,
                start: "top top",
                end: "+=300%",
                ease: "power3.inOut",
                scrub: 0.75,
            },
        });

        const galleries = [
            ".no-main-contact__image--1",
            ".no-main-contact__image--2",
            ".no-main-contact__image--3",
            ".no-main-contact__image--6",
            ".no-main-contact__image--7",
            ".no-main-contact__image--8",
        ];

        const object = this.section.querySelector(".no-main-contact__object");
        const backdrop = this.section.querySelector(
            ".no-main-contact__backdrop"
        );
        const content = this.section.querySelector(".no-main-contact__content");
        // const circle = this.section.querySelector(".no-main-contact__circle");

        // tl.to(circle, {
        //     width: "560vh",
        //     height: "560vh",
        // });

        tl.add("contactStart");

        galleries.forEach((gallery) => {
            tl.to(
                gallery,
                {
                    opacity: 1,
                    y: "60rem",
                    stagger: 0.05,
                },
                "contactStart"
            );
        });

        tl.to(
            object,
            {
                scale: 1,
            },
            "<"
        )
            .to(backdrop, {
                opacity: 0.45,
            })
            .to(
                content,
                {
                    scale: 1,
                    opacity: 1,
                },
                "<"
            );
    }
}
